/**
 * <pe-collection-search> — filters the cards of a "PE - Collection list" section
 * as the visitor types. After a minimum number of characters (data-min, default 3)
 * it shows only the items whose data-search value contains the query (case-insensitive,
 * partial match), and switches the slider into a static results grid. Clearing the
 * input (or dropping below the minimum) restores the full slider.
 */
if (!customElements.get('pe-collection-search')) {
  class PeCollectionSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.pe-cl-search__input');
      this.empty = this.querySelector('.pe-cl-search__empty');
      this.section = this.closest('.section-collection-list');
      this.min = parseInt(this.dataset.min, 10) || 3;

      if (!this.input || !this.section) return;

      // In grid mode, <paex-collection-index> owns filtering; here we only run the
      // icon expand/collapse. Otherwise (carousel) this element does the filtering.
      this.isGrid = this.dataset.mode === 'grid';
      if (!this.isGrid) {
        this.items = Array.from(this.section.querySelectorAll('.slider-slide[data-search]'));
        this.input.addEventListener('input', this.filter.bind(this));
      }

      // Icon mode: reveal the field next to the icon on click.
      this.toggleBtn = this.querySelector('.pe-cl-search__toggle');
      if (this.toggleBtn) {
        this.toggleBtn.addEventListener('click', this.toggleOpen.bind(this));
      }
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
    }

    toggleOpen() {
      if (this.classList.contains('is-open')) {
        this.close();
      } else {
        this.classList.add('is-open');
        if (this.toggleBtn) this.toggleBtn.setAttribute('aria-expanded', 'true');
        this.input.focus();
      }
    }

    close() {
      this.classList.remove('is-open');
      if (this.toggleBtn) this.toggleBtn.setAttribute('aria-expanded', 'false');
      if (this.input.value) {
        this.input.value = '';
        // Notify whoever is filtering (this element in carousel mode, the index in grid mode).
        this.input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    filter() {
      const query = this.input.value.trim().toLowerCase();
      const active = query.length >= this.min;

      this.section.classList.toggle('pe-cl--searching', active);

      if (!active) {
        this.items.forEach((item) => {
          item.style.display = '';
        });
        if (this.empty) this.empty.hidden = true;
        return;
      }

      let matches = 0;
      this.items.forEach((item) => {
        const haystack = item.getAttribute('data-search') || '';
        const hit = haystack.indexOf(query) !== -1;
        item.style.display = hit ? '' : 'none';
        if (hit) matches += 1;
      });

      if (this.empty) this.empty.hidden = matches !== 0;
    }
  }

  customElements.define('pe-collection-search', PeCollectionSearch);
}
